import React, { useEffect, useState } from "react";
import { Accordion, Card, Col, Container, Row } from "react-bootstrap";
import callImg from "../assets/images/contactus/call.svg";
import mailImg from "../assets/images/contactus/mail.svg";
import locationImg from "../assets/images/contactus/location.svg";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";
import { useDispatch } from "react-redux";
import { SET_LOADING } from "../redux/user";
import { toastErrorMessage } from "../utils/utils";

const Contactcarddetails = [
    { id: 1, title: "Phone", text: "+1 (865) 771-9190", img: callImg },
    {
        id: 2,
        title: "Email",
        text: "gujaratisamajoftampabay@gmail.com",
        img: mailImg,
    },
    {
        id: 3,
        title: "Address",
        text: "5513 Lynn Road, Tampa, FL 33624",
        img: locationImg,
    },
];

function Faqs() {
    const [faqList, setFaqList] = useState([]);
    const [userGuideList, setUserGuideList] = useState([]);
    const dispatch = useDispatch();
    const IMAGE_BASEURL = process.env.REACT_APP_IMAGE_BASEURL || "";

    const fetchFaqs = async () => {
        try {
            dispatch(SET_LOADING(true));
            const response = await API.get(api_paths.member.FAQ.GET_LIST);
            if (response.data?.payload?.result?.data) {
                setFaqList(response.data.payload.result.data);
            }
        } catch (error) {
            console.error("Error fetching FAQs:", error);
            // toastErrorMessage("Failed to load FAQs");
        } finally {
            dispatch(SET_LOADING(false));
        }
    };

    const fetchUserGuides = async () => {
        try {
            const response = await API.get(api_paths.member.USER_GUIDE.GET_LIST);
            if (response.data?.payload?.result?.data) {
                setUserGuideList(response.data.payload.result.data);
            }
        } catch (error) {
            console.error("Error fetching User Guides:", error);
        }
    };
console.log(faqList);

    useEffect(() => {
        fetchFaqs();
        fetchUserGuides();
    }, []);

    return (
        <>
            <section>
                <Container>
                    <Row>
                        <Col md={12} className="mt-5 contact-header text-center">
                            <h1 className="h1">FAQs</h1>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section className="contact-details-card py-4">
                <Container>
                    <Row className="g-4">
                        {Contactcarddetails.map((item) => (
                            <Col key={item.id} lg={4} md={6} sm={12}>
                                <Card className="contact-card h-100 border-0 p-3">
                                    <Card.Body className="d-flex align-items-center gap-3 p-0">
                                        <div className="icon-wrap d-flex align-items-center justify-content-center">
                                            <img
                                                src={item.img}
                                                alt={item.title}
                                                className="contactcard-icon"
                                            />
                                        </div>

                                        <div className="contact-text">
                                            <Card.Title className="mb-1 fw-semibold">
                                                {item.title}
                                            </Card.Title>
                                            <Card.Text className="fw-normal mb-0 text-muted small">
                                                {item.title === "Email" ? (
                                                    <a
                                                        href={`mailto:${item.text}`}
                                                        className="text-muted text-decoration-none"
                                                    >
                                                        {item.text}
                                                    </a>
                                                ) : item.title === "Phone" ? (
                                                    <a
                                                        href={`tel:${item.text}`}
                                                        className="text-muted text-decoration-none"
                                                    >
                                                        {item.text}
                                                    </a>
                                                ) : (
                                                    item.text
                                                )}
                                            </Card.Text>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
            {/* faqs and user Guide */}
            <section className="my-3">
                <Container>
                    <Row className="g-4">
                        <Col lg={8} md={12}>
                            <h2 className="fw-semibold f-26 text-main mb-4">FAQs</h2>
                            {faqList.length > 0 ? (
                                <Accordion defaultActiveKey="0" flush className="me-lg-5">
                                    {faqList.map((item, index) => (
                                        <Accordion.Item key={item._id || index} eventKey={index.toString()} className="accordian-item mb-2">
                                            <Accordion.Header className="accordian-header">
                                                <div className="accordian-header-text fw-semibold">{item.question}</div>
                                            </Accordion.Header>
                                            <Accordion.Body className="accordian-body">
                                                <div dangerouslySetInnerHTML={{ __html: item.answer }} className="accordian-description"/>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    ))}
                                </Accordion>
                            ) : (
                                <p className="text-muted">No FAQs found.</p>
                            )}
                        </Col>
                        {/* user-guide */}
                        <Col lg={4} md={12}>
                            <h2 className="fw-semibold f-26 text-main mb-4">User Guide</h2>
                            {userGuideList.length > 0 ? (
                                userGuideList.map((guide, index) => (
                                    <div key={guide._id || index} className="alert alert-warning d-flex justify-content-between align-items-center mb-4 py-2">
                                        <p className="mb-0 fw-semibold">{guide.title.charAt(0).toUpperCase() + guide.title.slice(1)}</p>
                                        <a 
                                            href={`${IMAGE_BASEURL}${guide.file_path}`} 
                                            target="_blank" 
                                            rel="noopener noreferrer" 
                                            className="my-1 orange text-decoration-none fw-medium"
                                        >
                                            View
                                        </a>
                                    </div>
                                ))
                            ) : (
                                <p className="text-muted">No User Guides found.</p>
                            )}
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    );
}

export default Faqs;
